import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { $Q } from '../utils/query-selector';
import 'swiper/css/bundle';

const initCarousel = () => {
  const productsCarousel = $Q('.products-carousel-swiper');

  if (!productsCarousel) return;

  const swiper = new Swiper(productsCarousel, {
    modules: [Pagination, Navigation],
    slidesPerView: 4,
    breakpoints: {
      280: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1260: {

      }
    },
    spaceBetween: 16,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
}

export default initCarousel;